// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ClaimGuarantorResponsibility,
    ClaimWorkerResponse,
    ClaimWorkflowHistoryItem,
    ClaimWorkflowStatusResponse,
    Invoice,
    ObjectActionPerformedResponse,
    ObjectNoResponse,
    ObjectPayloadResponse,
    ProviderClaim,
    ProviderClaimDetails,
    ProviderClaimSortType,
    ProviderCreateClaimInstitutionalPayload,
    ProviderCreateClaimProfessionalPayload,
    ProviderUpdateClaimPayload,
    SupportAddToClaimBundlePayload,
    SupportAdjustCollectionStrategyPayload,
    SupportAugmentPayload,
    SupportClaim,
    SupportClaimAugmentData,
    SupportClaimBundle,
    SupportClaimCalculationTest,
    SupportClaimDetails,
    SupportClaimPaymentData,
    SupportClaimSortType,
    SupportCreateClaimBundlePayload,
    SupportCreateClaimInstitutionalPayload,
    SupportCreateClaimProfessionalPayload,
    SupportFixPaymentStrategy,
    SupportSendClaimPayload,
    SupportSettleClaimPayload,
    SupportStoreSftpDocumentsToClaimResponse,
    SupportUpdateClaimPayload,
    TemporaryResultSet,
    ClaimGuarantorResponsibilityToJSON,
    ProviderCreateClaimInstitutionalPayloadToJSON,
    ProviderCreateClaimProfessionalPayloadToJSON,
    ProviderUpdateClaimPayloadToJSON,
    SupportAddToClaimBundlePayloadToJSON,
    SupportAdjustCollectionStrategyPayloadToJSON,
    SupportAugmentPayloadToJSON,
    SupportCreateClaimBundlePayloadToJSON,
    SupportCreateClaimInstitutionalPayloadToJSON,
    SupportCreateClaimProfessionalPayloadToJSON,
    SupportSendClaimPayloadToJSON,
    SupportSettleClaimPayloadToJSON,
    SupportUpdateClaimPayloadToJSON,
    ClaimWorkerResponseFromJSON,
    ClaimWorkflowHistoryItemFromJSON,
    ClaimWorkflowStatusResponseFromJSON,
    InvoiceFromJSON,
    ObjectActionPerformedResponseFromJSON,
    ObjectNoResponseFromJSON,
    ObjectPayloadResponseFromJSON,
    ProviderClaimFromJSON,
    ProviderClaimDetailsFromJSON,
    ProviderCreateClaimProfessionalPayloadFromJSON,
    SupportClaimFromJSON,
    SupportClaimAugmentDataFromJSON,
    SupportClaimBundleFromJSON,
    SupportClaimCalculationTestFromJSON,
    SupportClaimDetailsFromJSON,
    SupportClaimPaymentDataFromJSON,
    SupportCreateClaimProfessionalPayloadFromJSON,
    SupportFixPaymentStrategyFromJSON,
    SupportStoreSftpDocumentsToClaimResponseFromJSON,
    TemporaryResultSetFromJSON,
} from '../models';

export interface AddSupportClaimToBundleRequest {
    id: string;
    supportAddToClaimBundlePayload?: SupportAddToClaimBundlePayload;
}

export interface AdjustClaimCollectionStrategyRequest {
    id: string;
    supportAdjustCollectionStrategyPayload: SupportAdjustCollectionStrategyPayload;
}

export interface CreateProviderClaimInstitutionalRequest {
    providerCreateClaimInstitutionalPayload: ProviderCreateClaimInstitutionalPayload;
}

export interface CreateProviderClaimProfessionalRequest {
    providerCreateClaimProfessionalPayload: ProviderCreateClaimProfessionalPayload;
}

export interface CreateProviderClaimProfessionalPayloadRequest {
    id: string;
}

export interface CreateSupportClaimRequest {
    supportCreateClaimProfessionalPayload: SupportCreateClaimProfessionalPayload;
}

export interface CreateSupportClaimBundleRequest {
    supportCreateClaimBundlePayload: SupportCreateClaimBundlePayload;
}

export interface CreateSupportClaimInstitutionalRequest {
    supportCreateClaimInstitutionalPayload: SupportCreateClaimInstitutionalPayload;
}

export interface CreateSupportClaimProfessionalRequest {
    supportCreateClaimProfessionalPayload: SupportCreateClaimProfessionalPayload;
    xServiceLineControlNumbers?: Array<string>;
}

export interface CreateSupportClaimProfessionalPayloadRequest {
    id: string;
}

export interface DisableSupportClaimRequest {
    id: string;
}

export interface EnableSupportClaimRequest {
    id: string;
}

export interface GatherClaimAugmentDataRequest {
    id: string;
    supportAugmentPayload?: SupportAugmentPayload;
}

export interface GenerateBillingInvoiceRequest {
    id: string;
    force?: boolean;
}

export interface GenerateCarrierInvoiceRequest {
    id: string;
}

export interface GenerateInvoicesRequest {
    id: string;
}

export interface GenerateOptimizedRefreshRequest {
    id: string;
}

export interface GenerateResponsibilityRequest {
    id: string;
}

export interface GetAdminSupportCollectionsClaimsRequest {
    includeHumanInterventionNeeded?: boolean;
    filterNeedingMigration?: boolean;
}

export interface GetClaimBundleRequest {
    id: string;
}

export interface GetClaimPaymentDataRequest {
    id: string;
    cid: string;
}

export interface GetClaimWorkflowHistoryRequest {
    id: string;
}

export interface GetClaimWorkflowHistoryProviderRequest {
    id: string;
}

export interface GetPaymentFixStrategyRequest {
    id: string;
}

export interface GetProviderClaimRequest {
    id: string;
}

export interface GetProviderClaimDetailsRequest {
    id: string;
}

export interface GetSupportCalculationTestRequest {
    id: string;
}

export interface GetSupportClaimRequest {
    id: string;
}

export interface GetSupportClaimDetailsRequest {
    id: string;
}

export interface ListClaimPaymentDataRequest {
    cid: string;
    filterLatest?: Array<string>;
}

export interface ListProviderClaimsRequest {
    filterId?: Array<string>;
    filterClaimBundleId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderClaimsOrderEnum>;
    filterCreated?: Array<string>;
    filterExternalId?: Array<string>;
    filterFirst?: Array<string>;
    filterLast?: Array<string>;
    filterFirstLast?: Array<string>;
    filterNickname?: Array<string>;
    filterPayerAmount?: Array<string>;
    filterPaymentDate?: Array<string>;
    filterPaymentCount?: Array<string>;
    filterPaymentCountSettled?: Array<string>;
    filterPaymentCountUnsettled?: Array<string>;
    filterPaymentControlNumber?: Array<string>;
    filterPayerId?: Array<string>;
    filterPayerSubscriberId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterPatientId?: Array<string>;
    filterSellerId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterProviderId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterClaimType?: ListProviderClaimsFilterClaimTypeEnum;
    filterDiagnosis?: Array<string>;
    filterPriorAuthorizationNumber?: Array<string>;
    filterCharge?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterServiceCharge?: Array<string>;
    filterAccountNumber?: Array<string>;
    filterClaimCloseoutType?: Array<string>;
    filterClaimResponsibilityType?: Array<string>;
    filterClaimResponsibilityCategoryType?: Array<string>;
    filterClaimResponsibilityEvent?: Array<string>;
    filterStatus?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterInvoiceNumber?: Array<string>;
    sort?: Array<ProviderClaimSortType>;
}

export interface ListSearchProviderClaimsRequest {
    search: Array<string>;
    filterFromDos?: string;
}

export interface ListSearchSupportClaimsRequest {
    search: Array<string>;
    searchBy?: Array<string>;
    filterFromDos?: string;
}

export interface ListSupportClaimsRequest {
    filterId?: Array<string>;
    filterClaimBundleId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportClaimsOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterWorkflowStatus?: Array<string>;
    filterExternalId?: Array<string>;
    filterFirst?: Array<string>;
    filterLast?: Array<string>;
    filterFirstLast?: Array<string>;
    filterNickname?: Array<string>;
    filterPayerAmount?: Array<string>;
    filterPaymentDate?: Array<string>;
    filterPaymentCount?: Array<string>;
    filterPaymentCountSettled?: Array<string>;
    filterPaymentCountUnsettled?: Array<string>;
    filterPaymentControlNumber?: Array<string>;
    filterPayerId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterPayerSubscriberId?: Array<string>;
    filterPatientId?: Array<string>;
    filterSellerId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterProviderId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterClaimType?: ListSupportClaimsFilterClaimTypeEnum;
    filterDiagnosis?: Array<string>;
    filterPriorAuthorizationNumber?: Array<string>;
    filterCharge?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterServiceCharge?: Array<string>;
    filterAccountNumber?: Array<string>;
    filterClaimWithCollectionStatusType?: Array<string>;
    filterClaimWithCollectionStrategyType?: Array<string>;
    filterClaimCloseoutType?: Array<string>;
    filterClaimResponsibilityType?: Array<string>;
    filterClaimResponsibilityCategoryType?: Array<string>;
    filterClaimResponsibilityEvent?: Array<string>;
    filterStatus?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterInvoiceNumber?: Array<string>;
    sort?: Array<SupportClaimSortType>;
}

export interface PostClaimGuarantorResponsibilityRequest {
    id: string;
    claimGuarantorResponsibility: ClaimGuarantorResponsibility;
}

export interface PostClaimPaymentDataRequest {
    cid: string;
}

export interface PostPaymentFixStrategyRequest {
    id: string;
}

export interface PostProviderClaimGuarantorResponsibilityRequest {
    id: string;
    claimGuarantorResponsibility: ClaimGuarantorResponsibility;
}

export interface PostSupportClaimDisablePatientCollectionsRequest {
    id: string;
}

export interface PostSupportClaimEnablePatientCollectionsRequest {
    id: string;
    force?: boolean;
}

export interface PostSupportClaimGetAllScriptsDocumentMetaInfoRequest {
    id: string;
}

export interface PostSupportClaimMigratePatientCollectionsRequest {
    id: string;
}

export interface PostSupportClaimPreparePatientCollectionsRequest {
    id: string;
}

export interface PostSupportClaimRefreshAllScriptsRequest {
    id: string;
}

export interface PostSupportClaimRepairAccessCodeRequest {
    id: string;
    regeneratePdf?: boolean;
    repairCollections?: boolean;
}

export interface PostSupportClaimRepairClaimGuarantorEventsRequest {
    id: string;
}

export interface PostSupportClaimResyncAllScriptsDocumentsRequest {
    id: string;
}

export interface PostSupportClaimSyncCollectionPaymentsRequest {
    id: string;
}

export interface RefreshClaimChargemasterRequest {
    id: string;
    force?: boolean;
}

export interface RunClaimThroughWorkerRequest {
    id: string;
}

export interface SendClaimRequest {
    id: string;
    supportSendClaimPayload?: SupportSendClaimPayload;
}

export interface SettleClaimRequest {
    id: string;
    supportSettleClaimPayload: SupportSettleClaimPayload;
}

export interface StoreSftpDocumentsToClaimTaskRequest {
    id: string;
}

export interface UpdateClaimWorkflowStatusRequest {
    id: string;
}

export interface UpdateProviderClaimRequest {
    id: string;
    providerUpdateClaimPayload: ProviderUpdateClaimPayload;
}

export interface UpdateSupportClaimRequest {
    id: string;
    supportUpdateClaimPayload: SupportUpdateClaimPayload;
}

/**
 * no description
 */
export class ClaimApi extends runtime.BaseAPI {

    /**
     * Add claim to bundle
     * Add claim to bundle
     */
    async addSupportClaimToBundleRaw(requestParameters: AddSupportClaimToBundleRequest): Promise<runtime.ApiResponse<SupportClaimBundle>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling addSupportClaimToBundle.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/bundle/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportAddToClaimBundlePayloadToJSON(requestParameters['supportAddToClaimBundlePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimBundleFromJSON(jsonValue));
    }

    /**
     * Add claim to bundle
     * Add claim to bundle
     */
    async addSupportClaimToBundle(requestParameters: AddSupportClaimToBundleRequest): Promise<SupportClaimBundle> {
        const response = await this.addSupportClaimToBundleRaw(requestParameters);
        return await response.value();
    }

    /**
     * Adjusts the collection strategy for a claim
     * Adjusts the collection strategy for a claim
     */
    async adjustClaimCollectionStrategyRaw(requestParameters: AdjustClaimCollectionStrategyRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling adjustClaimCollectionStrategy.');
        }

        if (requestParameters['supportAdjustCollectionStrategyPayload'] === null || requestParameters['supportAdjustCollectionStrategyPayload'] === undefined) {
            throw new runtime.RequiredError('supportAdjustCollectionStrategyPayload','Required parameter requestParameters.supportAdjustCollectionStrategyPayload was null or undefined when calling adjustClaimCollectionStrategy.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/collection_strategy`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportAdjustCollectionStrategyPayloadToJSON(requestParameters['supportAdjustCollectionStrategyPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Adjusts the collection strategy for a claim
     * Adjusts the collection strategy for a claim
     */
    async adjustClaimCollectionStrategy(requestParameters: AdjustClaimCollectionStrategyRequest): Promise<ObjectNoResponse> {
        const response = await this.adjustClaimCollectionStrategyRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an institutional claim
     * Create an institutional claim
     */
    async createProviderClaimInstitutionalRaw(requestParameters: CreateProviderClaimInstitutionalRequest): Promise<runtime.ApiResponse<ProviderClaim>> {
        if (requestParameters['providerCreateClaimInstitutionalPayload'] === null || requestParameters['providerCreateClaimInstitutionalPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateClaimInstitutionalPayload','Required parameter requestParameters.providerCreateClaimInstitutionalPayload was null or undefined when calling createProviderClaimInstitutional.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/claim/institutional`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateClaimInstitutionalPayloadToJSON(requestParameters['providerCreateClaimInstitutionalPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClaimFromJSON(jsonValue));
    }

    /**
     * Create an institutional claim
     * Create an institutional claim
     */
    async createProviderClaimInstitutional(requestParameters: CreateProviderClaimInstitutionalRequest): Promise<ProviderClaim> {
        const response = await this.createProviderClaimInstitutionalRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a professional claim
     * Create a professional claim
     */
    async createProviderClaimProfessionalRaw(requestParameters: CreateProviderClaimProfessionalRequest): Promise<runtime.ApiResponse<ProviderClaim>> {
        if (requestParameters['providerCreateClaimProfessionalPayload'] === null || requestParameters['providerCreateClaimProfessionalPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateClaimProfessionalPayload','Required parameter requestParameters.providerCreateClaimProfessionalPayload was null or undefined when calling createProviderClaimProfessional.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/claim/professional`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateClaimProfessionalPayloadToJSON(requestParameters['providerCreateClaimProfessionalPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClaimFromJSON(jsonValue));
    }

    /**
     * Create a professional claim
     * Create a professional claim
     */
    async createProviderClaimProfessional(requestParameters: CreateProviderClaimProfessionalRequest): Promise<ProviderClaim> {
        const response = await this.createProviderClaimProfessionalRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a create claim professional payload
     * Create a create claim professional payload
     */
    async createProviderClaimProfessionalPayloadRaw(requestParameters: CreateProviderClaimProfessionalPayloadRequest): Promise<runtime.ApiResponse<ProviderCreateClaimProfessionalPayload>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createProviderClaimProfessionalPayload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/claim/professional/document/{id}/payload`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCreateClaimProfessionalPayloadFromJSON(jsonValue));
    }

    /**
     * Create a create claim professional payload
     * Create a create claim professional payload
     */
    async createProviderClaimProfessionalPayload(requestParameters: CreateProviderClaimProfessionalPayloadRequest): Promise<ProviderCreateClaimProfessionalPayload> {
        const response = await this.createProviderClaimProfessionalPayloadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a claim
     * Create a claim
     */
    async createSupportClaimRaw(requestParameters: CreateSupportClaimRequest): Promise<runtime.ApiResponse<SupportClaim>> {
        if (requestParameters['supportCreateClaimProfessionalPayload'] === null || requestParameters['supportCreateClaimProfessionalPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateClaimProfessionalPayload','Required parameter requestParameters.supportCreateClaimProfessionalPayload was null or undefined when calling createSupportClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateClaimProfessionalPayloadToJSON(requestParameters['supportCreateClaimProfessionalPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimFromJSON(jsonValue));
    }

    /**
     * Create a claim
     * Create a claim
     */
    async createSupportClaim(requestParameters: CreateSupportClaimRequest): Promise<SupportClaim> {
        const response = await this.createSupportClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates claim bundle with specified claim id as trigger
     * Creates claim bundle with specified claim id as trigger
     */
    async createSupportClaimBundleRaw(requestParameters: CreateSupportClaimBundleRequest): Promise<runtime.ApiResponse<SupportClaimBundle>> {
        if (requestParameters['supportCreateClaimBundlePayload'] === null || requestParameters['supportCreateClaimBundlePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateClaimBundlePayload','Required parameter requestParameters.supportCreateClaimBundlePayload was null or undefined when calling createSupportClaimBundle.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/bundle`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateClaimBundlePayloadToJSON(requestParameters['supportCreateClaimBundlePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimBundleFromJSON(jsonValue));
    }

    /**
     * Creates claim bundle with specified claim id as trigger
     * Creates claim bundle with specified claim id as trigger
     */
    async createSupportClaimBundle(requestParameters: CreateSupportClaimBundleRequest): Promise<SupportClaimBundle> {
        const response = await this.createSupportClaimBundleRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an institutional claim
     * Create an institutional claim
     */
    async createSupportClaimInstitutionalRaw(requestParameters: CreateSupportClaimInstitutionalRequest): Promise<runtime.ApiResponse<SupportClaim>> {
        if (requestParameters['supportCreateClaimInstitutionalPayload'] === null || requestParameters['supportCreateClaimInstitutionalPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateClaimInstitutionalPayload','Required parameter requestParameters.supportCreateClaimInstitutionalPayload was null or undefined when calling createSupportClaimInstitutional.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/institutional`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateClaimInstitutionalPayloadToJSON(requestParameters['supportCreateClaimInstitutionalPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimFromJSON(jsonValue));
    }

    /**
     * Create an institutional claim
     * Create an institutional claim
     */
    async createSupportClaimInstitutional(requestParameters: CreateSupportClaimInstitutionalRequest): Promise<SupportClaim> {
        const response = await this.createSupportClaimInstitutionalRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a professional claim
     * Create a professional claim
     */
    async createSupportClaimProfessionalRaw(requestParameters: CreateSupportClaimProfessionalRequest): Promise<runtime.ApiResponse<SupportClaim>> {
        if (requestParameters['supportCreateClaimProfessionalPayload'] === null || requestParameters['supportCreateClaimProfessionalPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateClaimProfessionalPayload','Required parameter requestParameters.supportCreateClaimProfessionalPayload was null or undefined when calling createSupportClaimProfessional.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/professional`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateClaimProfessionalPayloadToJSON(requestParameters['supportCreateClaimProfessionalPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimFromJSON(jsonValue));
    }

    /**
     * Create a professional claim
     * Create a professional claim
     */
    async createSupportClaimProfessional(requestParameters: CreateSupportClaimProfessionalRequest): Promise<SupportClaim> {
        const response = await this.createSupportClaimProfessionalRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a create claim professional payload
     * Create a create claim professional payload
     */
    async createSupportClaimProfessionalPayloadRaw(requestParameters: CreateSupportClaimProfessionalPayloadRequest): Promise<runtime.ApiResponse<SupportCreateClaimProfessionalPayload>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportClaimProfessionalPayload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/professional/document/{id}/payload`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCreateClaimProfessionalPayloadFromJSON(jsonValue));
    }

    /**
     * Create a create claim professional payload
     * Create a create claim professional payload
     */
    async createSupportClaimProfessionalPayload(requestParameters: CreateSupportClaimProfessionalPayloadRequest): Promise<SupportCreateClaimProfessionalPayload> {
        const response = await this.createSupportClaimProfessionalPayloadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a claim
     * Disable a claim
     */
    async disableSupportClaimRaw(requestParameters: DisableSupportClaimRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:claim", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a claim
     * Disable a claim
     */
    async disableSupportClaim(requestParameters: DisableSupportClaimRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable a claim
     * Enable a claim
     */
    async enableSupportClaimRaw(requestParameters: EnableSupportClaimRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enableSupportClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Enable a claim
     * Enable a claim
     */
    async enableSupportClaim(requestParameters: EnableSupportClaimRequest): Promise<ObjectNoResponse> {
        const response = await this.enableSupportClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gathers augment data and returns it
     * Gathers augment data and returns it
     */
    async gatherClaimAugmentDataRaw(requestParameters: GatherClaimAugmentDataRequest): Promise<runtime.ApiResponse<SupportClaimAugmentData>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling gatherClaimAugmentData.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/augment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportAugmentPayloadToJSON(requestParameters['supportAugmentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimAugmentDataFromJSON(jsonValue));
    }

    /**
     * Gathers augment data and returns it
     * Gathers augment data and returns it
     */
    async gatherClaimAugmentData(requestParameters: GatherClaimAugmentDataRequest): Promise<SupportClaimAugmentData> {
        const response = await this.gatherClaimAugmentDataRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate latest billing invoice from a claim
     * Generate latest billing invoice from a claim
     */
    async generateBillingInvoiceRaw(requestParameters: GenerateBillingInvoiceRequest): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling generateBillingInvoice.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/invoice/billing`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Generate latest billing invoice from a claim
     * Generate latest billing invoice from a claim
     */
    async generateBillingInvoice(requestParameters: GenerateBillingInvoiceRequest): Promise<Invoice> {
        const response = await this.generateBillingInvoiceRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate latest carrier invoice from a claim
     * Generate latest carrier invoice from a claim
     */
    async generateCarrierInvoiceRaw(requestParameters: GenerateCarrierInvoiceRequest): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling generateCarrierInvoice.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/invoice/carrier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Generate latest carrier invoice from a claim
     * Generate latest carrier invoice from a claim
     */
    async generateCarrierInvoice(requestParameters: GenerateCarrierInvoiceRequest): Promise<Invoice> {
        const response = await this.generateCarrierInvoiceRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate invoices from a claim
     * Generate latest invoices from a claim
     */
    async generateInvoicesRaw(requestParameters: GenerateInvoicesRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling generateInvoices.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Generate invoices from a claim
     * Generate latest invoices from a claim
     */
    async generateInvoices(requestParameters: GenerateInvoicesRequest): Promise<ObjectNoResponse> {
        const response = await this.generateInvoicesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate invoices from a claim (optimized)
     * Generate latest invoices from a claim (optimized)
     */
    async generateOptimizedRefreshRaw(requestParameters: GenerateOptimizedRefreshRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling generateOptimizedRefresh.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/optimized_refresh`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Generate invoices from a claim (optimized)
     * Generate latest invoices from a claim (optimized)
     */
    async generateOptimizedRefresh(requestParameters: GenerateOptimizedRefreshRequest): Promise<ObjectNoResponse> {
        const response = await this.generateOptimizedRefreshRaw(requestParameters);
        return await response.value();
    }

    /**
     * Calculate the claim responsibility
     * Calculate the claim responsibility
     */
    async generateResponsibilityRaw(requestParameters: GenerateResponsibilityRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling generateResponsibility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/responsibility`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Calculate the claim responsibility
     * Calculate the claim responsibility
     */
    async generateResponsibility(requestParameters: GenerateResponsibilityRequest): Promise<ObjectNoResponse> {
        const response = await this.generateResponsibilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * List claims that are for ready for patient collections
     * List claims that are for ready for patient collections
     */
    async getAdminSupportCollectionsClaimsRaw(requestParameters: GetAdminSupportCollectionsClaimsRequest): Promise<runtime.ApiResponse<TemporaryResultSet>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.includeHumanInterventionNeeded !== undefined) {
            queryParameters['includeHumanInterventionNeeded'] = requestParameters.includeHumanInterventionNeeded;
        }

        if (requestParameters.filterNeedingMigration !== undefined) {
            queryParameters['filterNeedingMigration'] = requestParameters.filterNeedingMigration;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/collections/claim`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryResultSetFromJSON(jsonValue));
    }

    /**
     * List claims that are for ready for patient collections
     * List claims that are for ready for patient collections
     */
    async getAdminSupportCollectionsClaims(requestParameters: GetAdminSupportCollectionsClaimsRequest): Promise<TemporaryResultSet> {
        const response = await this.getAdminSupportCollectionsClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get claim bundle details
     * Get claim bundle details
     */
    async getClaimBundleRaw(requestParameters: GetClaimBundleRequest): Promise<runtime.ApiResponse<SupportClaimBundle>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getClaimBundle.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/bundle/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimBundleFromJSON(jsonValue));
    }

    /**
     * Get claim bundle details
     * Get claim bundle details
     */
    async getClaimBundle(requestParameters: GetClaimBundleRequest): Promise<SupportClaimBundle> {
        const response = await this.getClaimBundleRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a claim payment data
     * Get a claim payment data
     */
    async getClaimPaymentDataRaw(requestParameters: GetClaimPaymentDataRequest): Promise<runtime.ApiResponse<SupportClaimPaymentData>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getClaimPaymentData.');
        }

        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling getClaimPaymentData.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{cid}/payment_data/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimPaymentDataFromJSON(jsonValue));
    }

    /**
     * Get a claim payment data
     * Get a claim payment data
     */
    async getClaimPaymentData(requestParameters: GetClaimPaymentDataRequest): Promise<SupportClaimPaymentData> {
        const response = await this.getClaimPaymentDataRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the claim workflow history for the specified claim.
     * Get claim workflow history
     */
    async getClaimWorkflowHistoryRaw(requestParameters: GetClaimWorkflowHistoryRequest): Promise<runtime.ApiResponse<Array<ClaimWorkflowHistoryItem>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getClaimWorkflowHistory.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/worker/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimWorkflowHistoryItemFromJSON));
    }

    /**
     * Gets the claim workflow history for the specified claim.
     * Get claim workflow history
     */
    async getClaimWorkflowHistory(requestParameters: GetClaimWorkflowHistoryRequest): Promise<Array<ClaimWorkflowHistoryItem>> {
        const response = await this.getClaimWorkflowHistoryRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the claim workflow history for the specified claim.
     * Get claim workflow history
     */
    async getClaimWorkflowHistoryProviderRaw(requestParameters: GetClaimWorkflowHistoryProviderRequest): Promise<runtime.ApiResponse<Array<ClaimWorkflowHistoryItem>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getClaimWorkflowHistoryProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/claim/{id}/worker/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimWorkflowHistoryItemFromJSON));
    }

    /**
     * Gets the claim workflow history for the specified claim.
     * Get claim workflow history
     */
    async getClaimWorkflowHistoryProvider(requestParameters: GetClaimWorkflowHistoryProviderRequest): Promise<Array<ClaimWorkflowHistoryItem>> {
        const response = await this.getClaimWorkflowHistoryProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a payment fix strategy
     * Get a payment fix strategy
     */
    async getPaymentFixStrategyRaw(requestParameters: GetPaymentFixStrategyRequest): Promise<runtime.ApiResponse<SupportFixPaymentStrategy>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPaymentFixStrategy.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/payment_fix`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportFixPaymentStrategyFromJSON(jsonValue));
    }

    /**
     * Get a payment fix strategy
     * Get a payment fix strategy
     */
    async getPaymentFixStrategy(requestParameters: GetPaymentFixStrategyRequest): Promise<SupportFixPaymentStrategy> {
        const response = await this.getPaymentFixStrategyRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a claim
     * Get a claim
     */
    async getProviderClaimRaw(requestParameters: GetProviderClaimRequest): Promise<runtime.ApiResponse<ProviderClaim>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/claim/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClaimFromJSON(jsonValue));
    }

    /**
     * Gets a claim
     * Get a claim
     */
    async getProviderClaim(requestParameters: GetProviderClaimRequest): Promise<ProviderClaim> {
        const response = await this.getProviderClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets claim details
     * Get claim details
     */
    async getProviderClaimDetailsRaw(requestParameters: GetProviderClaimDetailsRequest): Promise<runtime.ApiResponse<ProviderClaimDetails>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderClaimDetails.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/claim/{id}/details`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClaimDetailsFromJSON(jsonValue));
    }

    /**
     * Gets claim details
     * Get claim details
     */
    async getProviderClaimDetails(requestParameters: GetProviderClaimDetailsRequest): Promise<ProviderClaimDetails> {
        const response = await this.getProviderClaimDetailsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets claim details
     * Get claim details
     */
    async getSupportCalculationTestRaw(requestParameters: GetSupportCalculationTestRequest): Promise<runtime.ApiResponse<SupportClaimCalculationTest>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportCalculationTest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/calculation_test`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimCalculationTestFromJSON(jsonValue));
    }

    /**
     * Gets claim details
     * Get claim details
     */
    async getSupportCalculationTest(requestParameters: GetSupportCalculationTestRequest): Promise<SupportClaimCalculationTest> {
        const response = await this.getSupportCalculationTestRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a claim
     * Get a claim
     */
    async getSupportClaimRaw(requestParameters: GetSupportClaimRequest): Promise<runtime.ApiResponse<SupportClaim>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimFromJSON(jsonValue));
    }

    /**
     * Gets a claim
     * Get a claim
     */
    async getSupportClaim(requestParameters: GetSupportClaimRequest): Promise<SupportClaim> {
        const response = await this.getSupportClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets claim details
     * Get claim details
     */
    async getSupportClaimDetailsRaw(requestParameters: GetSupportClaimDetailsRequest): Promise<runtime.ApiResponse<SupportClaimDetails>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportClaimDetails.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/details`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimDetailsFromJSON(jsonValue));
    }

    /**
     * Gets claim details
     * Get claim details
     */
    async getSupportClaimDetails(requestParameters: GetSupportClaimDetailsRequest): Promise<SupportClaimDetails> {
        const response = await this.getSupportClaimDetailsRaw(requestParameters);
        return await response.value();
    }

    /**
     * List claim payment data
     * List claim payment data
     */
    async listClaimPaymentDataRaw(requestParameters: ListClaimPaymentDataRequest): Promise<runtime.ApiResponse<Array<SupportClaimPaymentData>>> {
        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling listClaimPaymentData.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterLatest) {
            queryParameters['filterLatest'] = requestParameters.filterLatest;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{cid}/payment_data`.replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportClaimPaymentDataFromJSON));
    }

    /**
     * List claim payment data
     * List claim payment data
     */
    async listClaimPaymentData(requestParameters: ListClaimPaymentDataRequest): Promise<Array<SupportClaimPaymentData>> {
        const response = await this.listClaimPaymentDataRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of claims
     * Get a list of claims
     */
    async listProviderClaimsRaw(requestParameters: ListProviderClaimsRequest): Promise<runtime.ApiResponse<Array<ProviderClaim>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.filterClaimBundleId) {
            queryParameters['filterClaimBundleId'] = requestParameters.filterClaimBundleId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterNickname) {
            queryParameters['filterNickname'] = requestParameters.filterNickname;
        }

        if (requestParameters.filterPayerAmount) {
            queryParameters['filterPayerAmount'] = requestParameters.filterPayerAmount;
        }

        if (requestParameters.filterPaymentDate) {
            queryParameters['filterPaymentDate'] = requestParameters.filterPaymentDate;
        }

        if (requestParameters.filterPaymentCount) {
            queryParameters['filterPaymentCount'] = requestParameters.filterPaymentCount;
        }

        if (requestParameters.filterPaymentCountSettled) {
            queryParameters['filterPaymentCountSettled'] = requestParameters.filterPaymentCountSettled;
        }

        if (requestParameters.filterPaymentCountUnsettled) {
            queryParameters['filterPaymentCountUnsettled'] = requestParameters.filterPaymentCountUnsettled;
        }

        if (requestParameters.filterPaymentControlNumber) {
            queryParameters['filterPaymentControlNumber'] = requestParameters.filterPaymentControlNumber;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterPayerSubscriberId) {
            queryParameters['filterPayerSubscriberId'] = requestParameters.filterPayerSubscriberId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterSellerId) {
            queryParameters['filterSellerId'] = requestParameters.filterSellerId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterClaimType !== undefined) {
            queryParameters['filterClaimType'] = requestParameters.filterClaimType;
        }

        if (requestParameters.filterDiagnosis) {
            queryParameters['filterDiagnosis'] = requestParameters.filterDiagnosis;
        }

        if (requestParameters.filterPriorAuthorizationNumber) {
            queryParameters['filterPriorAuthorizationNumber'] = requestParameters.filterPriorAuthorizationNumber;
        }

        if (requestParameters.filterCharge) {
            queryParameters['filterCharge'] = requestParameters.filterCharge;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterServiceCharge) {
            queryParameters['filterServiceCharge'] = requestParameters.filterServiceCharge;
        }

        if (requestParameters.filterAccountNumber) {
            queryParameters['filterAccountNumber'] = requestParameters.filterAccountNumber;
        }

        if (requestParameters.filterClaimCloseoutType) {
            queryParameters['filterClaimCloseoutType'] = requestParameters.filterClaimCloseoutType;
        }

        if (requestParameters.filterClaimResponsibilityType) {
            queryParameters['filterClaimResponsibilityType'] = requestParameters.filterClaimResponsibilityType;
        }

        if (requestParameters.filterClaimResponsibilityCategoryType) {
            queryParameters['filterClaimResponsibilityCategoryType'] = requestParameters.filterClaimResponsibilityCategoryType;
        }

        if (requestParameters.filterClaimResponsibilityEvent) {
            queryParameters['filterClaimResponsibilityEvent'] = requestParameters.filterClaimResponsibilityEvent;
        }

        if (requestParameters.filterStatus) {
            queryParameters['filterStatus'] = requestParameters.filterStatus;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterInvoiceNumber) {
            queryParameters['filterInvoiceNumber'] = requestParameters.filterInvoiceNumber;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/claim`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderClaimFromJSON));
    }

    /**
     * Gets a list of claims
     * Get a list of claims
     */
    async listProviderClaims(requestParameters: ListProviderClaimsRequest): Promise<Array<ProviderClaim>> {
        const response = await this.listProviderClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of claims
     * Get a list of claims
     */
    async listSearchProviderClaimsRaw(requestParameters: ListSearchProviderClaimsRequest): Promise<runtime.ApiResponse<Array<ProviderClaim>>> {
        if (requestParameters['search'] === null || requestParameters['search'] === undefined) {
            throw new runtime.RequiredError('search','Required parameter requestParameters.search was null or undefined when calling listSearchProviderClaims.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.search) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.filterFromDos !== undefined) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/claim/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderClaimFromJSON));
    }

    /**
     * Gets a list of claims
     * Get a list of claims
     */
    async listSearchProviderClaims(requestParameters: ListSearchProviderClaimsRequest): Promise<Array<ProviderClaim>> {
        const response = await this.listSearchProviderClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of claims
     * Get a list of claims
     */
    async listSearchSupportClaimsRaw(requestParameters: ListSearchSupportClaimsRequest): Promise<runtime.ApiResponse<Array<SupportClaim>>> {
        if (requestParameters['search'] === null || requestParameters['search'] === undefined) {
            throw new runtime.RequiredError('search','Required parameter requestParameters.search was null or undefined when calling listSearchSupportClaims.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.search) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.searchBy) {
            queryParameters['searchBy'] = requestParameters.searchBy;
        }

        if (requestParameters.filterFromDos !== undefined) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportClaimFromJSON));
    }

    /**
     * Gets a list of claims
     * Get a list of claims
     */
    async listSearchSupportClaims(requestParameters: ListSearchSupportClaimsRequest): Promise<Array<SupportClaim>> {
        const response = await this.listSearchSupportClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of claims
     * Get a list of claims
     */
    async listSupportClaimsRaw(requestParameters: ListSupportClaimsRequest): Promise<runtime.ApiResponse<Array<SupportClaim>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.filterClaimBundleId) {
            queryParameters['filterClaimBundleId'] = requestParameters.filterClaimBundleId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterWorkflowStatus) {
            queryParameters['filterWorkflowStatus'] = requestParameters.filterWorkflowStatus;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterNickname) {
            queryParameters['filterNickname'] = requestParameters.filterNickname;
        }

        if (requestParameters.filterPayerAmount) {
            queryParameters['filterPayerAmount'] = requestParameters.filterPayerAmount;
        }

        if (requestParameters.filterPaymentDate) {
            queryParameters['filterPaymentDate'] = requestParameters.filterPaymentDate;
        }

        if (requestParameters.filterPaymentCount) {
            queryParameters['filterPaymentCount'] = requestParameters.filterPaymentCount;
        }

        if (requestParameters.filterPaymentCountSettled) {
            queryParameters['filterPaymentCountSettled'] = requestParameters.filterPaymentCountSettled;
        }

        if (requestParameters.filterPaymentCountUnsettled) {
            queryParameters['filterPaymentCountUnsettled'] = requestParameters.filterPaymentCountUnsettled;
        }

        if (requestParameters.filterPaymentControlNumber) {
            queryParameters['filterPaymentControlNumber'] = requestParameters.filterPaymentControlNumber;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterPayerSubscriberId) {
            queryParameters['filterPayerSubscriberId'] = requestParameters.filterPayerSubscriberId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterSellerId) {
            queryParameters['filterSellerId'] = requestParameters.filterSellerId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterClaimType !== undefined) {
            queryParameters['filterClaimType'] = requestParameters.filterClaimType;
        }

        if (requestParameters.filterDiagnosis) {
            queryParameters['filterDiagnosis'] = requestParameters.filterDiagnosis;
        }

        if (requestParameters.filterPriorAuthorizationNumber) {
            queryParameters['filterPriorAuthorizationNumber'] = requestParameters.filterPriorAuthorizationNumber;
        }

        if (requestParameters.filterCharge) {
            queryParameters['filterCharge'] = requestParameters.filterCharge;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterServiceCharge) {
            queryParameters['filterServiceCharge'] = requestParameters.filterServiceCharge;
        }

        if (requestParameters.filterAccountNumber) {
            queryParameters['filterAccountNumber'] = requestParameters.filterAccountNumber;
        }

        if (requestParameters.filterClaimWithCollectionStatusType) {
            queryParameters['filterClaimWithCollectionStatusType'] = requestParameters.filterClaimWithCollectionStatusType;
        }

        if (requestParameters.filterClaimWithCollectionStrategyType) {
            queryParameters['filterClaimWithCollectionStrategyType'] = requestParameters.filterClaimWithCollectionStrategyType;
        }

        if (requestParameters.filterClaimCloseoutType) {
            queryParameters['filterClaimCloseoutType'] = requestParameters.filterClaimCloseoutType;
        }

        if (requestParameters.filterClaimResponsibilityType) {
            queryParameters['filterClaimResponsibilityType'] = requestParameters.filterClaimResponsibilityType;
        }

        if (requestParameters.filterClaimResponsibilityCategoryType) {
            queryParameters['filterClaimResponsibilityCategoryType'] = requestParameters.filterClaimResponsibilityCategoryType;
        }

        if (requestParameters.filterClaimResponsibilityEvent) {
            queryParameters['filterClaimResponsibilityEvent'] = requestParameters.filterClaimResponsibilityEvent;
        }

        if (requestParameters.filterStatus) {
            queryParameters['filterStatus'] = requestParameters.filterStatus;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterInvoiceNumber) {
            queryParameters['filterInvoiceNumber'] = requestParameters.filterInvoiceNumber;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportClaimFromJSON));
    }

    /**
     * Gets a list of claims
     * Get a list of claims
     */
    async listSupportClaims(requestParameters: ListSupportClaimsRequest): Promise<Array<SupportClaim>> {
        const response = await this.listSupportClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update max guarantor responsibility for a claim
     * Update max guarantor responsibility for a claim
     */
    async postClaimGuarantorResponsibilityRaw(requestParameters: PostClaimGuarantorResponsibilityRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postClaimGuarantorResponsibility.');
        }

        if (requestParameters['claimGuarantorResponsibility'] === null || requestParameters['claimGuarantorResponsibility'] === undefined) {
            throw new runtime.RequiredError('claimGuarantorResponsibility','Required parameter requestParameters.claimGuarantorResponsibility was null or undefined when calling postClaimGuarantorResponsibility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/guarantor_responsibility`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimGuarantorResponsibilityToJSON(requestParameters['claimGuarantorResponsibility']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update max guarantor responsibility for a claim
     * Update max guarantor responsibility for a claim
     */
    async postClaimGuarantorResponsibility(requestParameters: PostClaimGuarantorResponsibilityRequest): Promise<ObjectNoResponse> {
        const response = await this.postClaimGuarantorResponsibilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create claim payment data
     * Create claim payment data
     */
    async postClaimPaymentDataRaw(requestParameters: PostClaimPaymentDataRequest): Promise<runtime.ApiResponse<SupportClaimPaymentData>> {
        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling postClaimPaymentData.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{cid}/payment_data`.replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimPaymentDataFromJSON(jsonValue));
    }

    /**
     * Create claim payment data
     * Create claim payment data
     */
    async postClaimPaymentData(requestParameters: PostClaimPaymentDataRequest): Promise<SupportClaimPaymentData> {
        const response = await this.postClaimPaymentDataRaw(requestParameters);
        return await response.value();
    }

    /**
     * Execute a payment fix strategy
     * Execute a payment fix strategy
     */
    async postPaymentFixStrategyRaw(requestParameters: PostPaymentFixStrategyRequest): Promise<runtime.ApiResponse<SupportFixPaymentStrategy>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postPaymentFixStrategy.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/payment_fix`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportFixPaymentStrategyFromJSON(jsonValue));
    }

    /**
     * Execute a payment fix strategy
     * Execute a payment fix strategy
     */
    async postPaymentFixStrategy(requestParameters: PostPaymentFixStrategyRequest): Promise<SupportFixPaymentStrategy> {
        const response = await this.postPaymentFixStrategyRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update max guarantor responsibility for a claim
     * Update max guarantor responsibility for a claim
     */
    async postProviderClaimGuarantorResponsibilityRaw(requestParameters: PostProviderClaimGuarantorResponsibilityRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderClaimGuarantorResponsibility.');
        }

        if (requestParameters['claimGuarantorResponsibility'] === null || requestParameters['claimGuarantorResponsibility'] === undefined) {
            throw new runtime.RequiredError('claimGuarantorResponsibility','Required parameter requestParameters.claimGuarantorResponsibility was null or undefined when calling postProviderClaimGuarantorResponsibility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/claim/{id}/maximum_guarantor_responsibility`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimGuarantorResponsibilityToJSON(requestParameters['claimGuarantorResponsibility']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update max guarantor responsibility for a claim
     * Update max guarantor responsibility for a claim
     */
    async postProviderClaimGuarantorResponsibility(requestParameters: PostProviderClaimGuarantorResponsibilityRequest): Promise<ObjectNoResponse> {
        const response = await this.postProviderClaimGuarantorResponsibilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable patient collections
     * Enable patient collections
     */
    async postSupportClaimDisablePatientCollectionsRaw(requestParameters: PostSupportClaimDisablePatientCollectionsRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportClaimDisablePatientCollections.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/disable_patient_collections`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Enable patient collections
     * Enable patient collections
     */
    async postSupportClaimDisablePatientCollections(requestParameters: PostSupportClaimDisablePatientCollectionsRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportClaimDisablePatientCollectionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable patient collections
     * Enable patient collections
     */
    async postSupportClaimEnablePatientCollectionsRaw(requestParameters: PostSupportClaimEnablePatientCollectionsRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportClaimEnablePatientCollections.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/enable_patient_collections`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Enable patient collections
     * Enable patient collections
     */
    async postSupportClaimEnablePatientCollections(requestParameters: PostSupportClaimEnablePatientCollectionsRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportClaimEnablePatientCollectionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get Allscripts document metainfo for the claim
     * Get Allscripts document metainfo for the claim
     */
    async postSupportClaimGetAllScriptsDocumentMetaInfoRaw(requestParameters: PostSupportClaimGetAllScriptsDocumentMetaInfoRequest): Promise<runtime.ApiResponse<ObjectPayloadResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportClaimGetAllScriptsDocumentMetaInfo.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/get_allscripts_document_metainfo`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectPayloadResponseFromJSON(jsonValue));
    }

    /**
     * Get Allscripts document metainfo for the claim
     * Get Allscripts document metainfo for the claim
     */
    async postSupportClaimGetAllScriptsDocumentMetaInfo(requestParameters: PostSupportClaimGetAllScriptsDocumentMetaInfoRequest): Promise<ObjectPayloadResponse> {
        const response = await this.postSupportClaimGetAllScriptsDocumentMetaInfoRaw(requestParameters);
        return await response.value();
    }

    /**
     * Migrate claim patient collections
     * Migrate claim patient collections
     */
    async postSupportClaimMigratePatientCollectionsRaw(requestParameters: PostSupportClaimMigratePatientCollectionsRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportClaimMigratePatientCollections.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/migrate_patient_collections`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Migrate claim patient collections
     * Migrate claim patient collections
     */
    async postSupportClaimMigratePatientCollections(requestParameters: PostSupportClaimMigratePatientCollectionsRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportClaimMigratePatientCollectionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Prepare patient collections
     * Prepare patient collections
     */
    async postSupportClaimPreparePatientCollectionsRaw(requestParameters: PostSupportClaimPreparePatientCollectionsRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportClaimPreparePatientCollections.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/prepare_patient_collections`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Prepare patient collections
     * Prepare patient collections
     */
    async postSupportClaimPreparePatientCollections(requestParameters: PostSupportClaimPreparePatientCollectionsRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportClaimPreparePatientCollectionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Refresh Allscripts for the claim
     * Refresh Allscripts for the claim
     */
    async postSupportClaimRefreshAllScriptsRaw(requestParameters: PostSupportClaimRefreshAllScriptsRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportClaimRefreshAllScripts.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/refresh_allscripts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Refresh Allscripts for the claim
     * Refresh Allscripts for the claim
     */
    async postSupportClaimRefreshAllScripts(requestParameters: PostSupportClaimRefreshAllScriptsRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportClaimRefreshAllScriptsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Repair access code
     * Repair access code
     */
    async postSupportClaimRepairAccessCodeRaw(requestParameters: PostSupportClaimRepairAccessCodeRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportClaimRepairAccessCode.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.regeneratePdf !== undefined) {
            queryParameters['regeneratePdf'] = requestParameters.regeneratePdf;
        }

        if (requestParameters.repairCollections !== undefined) {
            queryParameters['repairCollections'] = requestParameters.repairCollections;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/repair_access_code`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Repair access code
     * Repair access code
     */
    async postSupportClaimRepairAccessCode(requestParameters: PostSupportClaimRepairAccessCodeRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportClaimRepairAccessCodeRaw(requestParameters);
        return await response.value();
    }

    /**
     * Repair claim guarantor events
     * Repair claim guarantor events
     */
    async postSupportClaimRepairClaimGuarantorEventsRaw(requestParameters: PostSupportClaimRepairClaimGuarantorEventsRequest): Promise<runtime.ApiResponse<ObjectActionPerformedResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportClaimRepairClaimGuarantorEvents.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/repair_claim_guarantor_events`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectActionPerformedResponseFromJSON(jsonValue));
    }

    /**
     * Repair claim guarantor events
     * Repair claim guarantor events
     */
    async postSupportClaimRepairClaimGuarantorEvents(requestParameters: PostSupportClaimRepairClaimGuarantorEventsRequest): Promise<ObjectActionPerformedResponse> {
        const response = await this.postSupportClaimRepairClaimGuarantorEventsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Resync Allscripts documents for the claim
     * Resync Allscripts documents for the claim
     */
    async postSupportClaimResyncAllScriptsDocumentsRaw(requestParameters: PostSupportClaimResyncAllScriptsDocumentsRequest): Promise<runtime.ApiResponse<ObjectPayloadResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportClaimResyncAllScriptsDocuments.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/resync_allscripts_documents`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectPayloadResponseFromJSON(jsonValue));
    }

    /**
     * Resync Allscripts documents for the claim
     * Resync Allscripts documents for the claim
     */
    async postSupportClaimResyncAllScriptsDocuments(requestParameters: PostSupportClaimResyncAllScriptsDocumentsRequest): Promise<ObjectPayloadResponse> {
        const response = await this.postSupportClaimResyncAllScriptsDocumentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Sync collection payments
     * Sync collection payments
     */
    async postSupportClaimSyncCollectionPaymentsRaw(requestParameters: PostSupportClaimSyncCollectionPaymentsRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportClaimSyncCollectionPayments.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/sync_collection_payments`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Sync collection payments
     * Sync collection payments
     */
    async postSupportClaimSyncCollectionPayments(requestParameters: PostSupportClaimSyncCollectionPaymentsRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportClaimSyncCollectionPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Updates the claim chargemaster
     * Updates the claim chargemaster
     */
    async refreshClaimChargemasterRaw(requestParameters: RefreshClaimChargemasterRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling refreshClaimChargemaster.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/chargemaster_refresh`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Updates the claim chargemaster
     * Updates the claim chargemaster
     */
    async refreshClaimChargemaster(requestParameters: RefreshClaimChargemasterRequest): Promise<ObjectNoResponse> {
        const response = await this.refreshClaimChargemasterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Force run a claim through the worker. It will attempt to run 1 step with each call.
     * Trigger a worker for a claim
     */
    async runClaimThroughWorkerRaw(requestParameters: RunClaimThroughWorkerRequest): Promise<runtime.ApiResponse<ClaimWorkerResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling runClaimThroughWorker.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/run_worker`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkerResponseFromJSON(jsonValue));
    }

    /**
     * Force run a claim through the worker. It will attempt to run 1 step with each call.
     * Trigger a worker for a claim
     */
    async runClaimThroughWorker(requestParameters: RunClaimThroughWorkerRequest): Promise<ClaimWorkerResponse> {
        const response = await this.runClaimThroughWorkerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Convenience method to send a claim using default settings
     * Convenience method to send a claim using default settings
     */
    async sendClaimRaw(requestParameters: SendClaimRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling sendClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/send`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportSendClaimPayloadToJSON(requestParameters['supportSendClaimPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Convenience method to send a claim using default settings
     * Convenience method to send a claim using default settings
     */
    async sendClaim(requestParameters: SendClaimRequest): Promise<ObjectNoResponse> {
        const response = await this.sendClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Settle a claim
     * Settle a claim
     */
    async settleClaimRaw(requestParameters: SettleClaimRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling settleClaim.');
        }

        if (requestParameters['supportSettleClaimPayload'] === null || requestParameters['supportSettleClaimPayload'] === undefined) {
            throw new runtime.RequiredError('supportSettleClaimPayload','Required parameter requestParameters.supportSettleClaimPayload was null or undefined when calling settleClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/settle`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportSettleClaimPayloadToJSON(requestParameters['supportSettleClaimPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Settle a claim
     * Settle a claim
     */
    async settleClaim(requestParameters: SettleClaimRequest): Promise<ObjectNoResponse> {
        const response = await this.settleClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Stores documents from the Enter SFTP server
     * Stores documents from the Enter SFTP server
     */
    async storeSftpDocumentsToClaimTaskRaw(requestParameters: StoreSftpDocumentsToClaimTaskRequest): Promise<runtime.ApiResponse<SupportStoreSftpDocumentsToClaimResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling storeSftpDocumentsToClaimTask.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/store_sftp_documents`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportStoreSftpDocumentsToClaimResponseFromJSON(jsonValue));
    }

    /**
     * Stores documents from the Enter SFTP server
     * Stores documents from the Enter SFTP server
     */
    async storeSftpDocumentsToClaimTask(requestParameters: StoreSftpDocumentsToClaimTaskRequest): Promise<SupportStoreSftpDocumentsToClaimResponse> {
        const response = await this.storeSftpDocumentsToClaimTaskRaw(requestParameters);
        return await response.value();
    }

    /**
     * Updates the workflow status for a claim using the latest claim details.
     * Run a claim workflow status update
     */
    async updateClaimWorkflowStatusRaw(requestParameters: UpdateClaimWorkflowStatusRequest): Promise<runtime.ApiResponse<ClaimWorkflowStatusResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateClaimWorkflowStatus.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}/workflow_status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkflowStatusResponseFromJSON(jsonValue));
    }

    /**
     * Updates the workflow status for a claim using the latest claim details.
     * Run a claim workflow status update
     */
    async updateClaimWorkflowStatus(requestParameters: UpdateClaimWorkflowStatusRequest): Promise<ClaimWorkflowStatusResponse> {
        const response = await this.updateClaimWorkflowStatusRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a claim
     * Update a claim
     */
    async updateProviderClaimRaw(requestParameters: UpdateProviderClaimRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProviderClaim.');
        }

        if (requestParameters['providerUpdateClaimPayload'] === null || requestParameters['providerUpdateClaimPayload'] === undefined) {
            throw new runtime.RequiredError('providerUpdateClaimPayload','Required parameter requestParameters.providerUpdateClaimPayload was null or undefined when calling updateProviderClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/claim/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderUpdateClaimPayloadToJSON(requestParameters['providerUpdateClaimPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a claim
     * Update a claim
     */
    async updateProviderClaim(requestParameters: UpdateProviderClaimRequest): Promise<ObjectNoResponse> {
        const response = await this.updateProviderClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a claim
     * Update a claim
     */
    async updateSupportClaimRaw(requestParameters: UpdateSupportClaimRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportClaim.');
        }

        if (requestParameters['supportUpdateClaimPayload'] === null || requestParameters['supportUpdateClaimPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateClaimPayload','Required parameter requestParameters.supportUpdateClaimPayload was null or undefined when calling updateSupportClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/claim/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateClaimPayloadToJSON(requestParameters['supportUpdateClaimPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a claim
     * Update a claim
     */
    async updateSupportClaim(requestParameters: UpdateSupportClaimRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportClaimRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderClaimsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderClaimsFilterClaimTypeEnum {
    PROFESSIONAL = 'PROFESSIONAL',
    INSTITUTIONAL = 'INSTITUTIONAL',
    DENTAL = 'DENTAL',
    NYNF3 = 'NYNF3'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportClaimsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportClaimsFilterClaimTypeEnum {
    PROFESSIONAL = 'PROFESSIONAL',
    INSTITUTIONAL = 'INSTITUTIONAL',
    DENTAL = 'DENTAL',
    NYNF3 = 'NYNF3'
}
